import { commentItems } from '@/pages/home/mocks/data';

export default function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <span className="inline-block px-3 py-1 text-xs font-medium bg-secondary-100 text-secondary-700 rounded-full mb-3">
            瓜友热议
          </span>
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-900">吃瓜群众有话说</h2>
          <p className="text-foreground-500 mt-2 text-sm">来自百万瓜友的真实声音</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {commentItems.map((comment) => (
            <div key={comment.id} className="p-5 rounded-lg bg-background-50 border border-background-200/70">
              <div className="flex items-center gap-3 mb-3">
                <div className="w-10 h-10 rounded-full overflow-hidden flex-shrink-0">
                  <img src={comment.avatar} alt={comment.nickname} className="w-full h-full object-cover" />
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2">
                    <span className="text-sm font-semibold text-foreground-800">{comment.nickname}</span>
                    <span className="px-1.5 py-0.5 bg-accent-100 text-accent-700 text-[10px] font-medium rounded whitespace-nowrap">{comment.tag}</span>
                  </div>
                  <span className="text-xs text-foreground-400">{comment.time}</span>
                </div>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed mb-3">{comment.content}</p>
              <div className="flex items-center gap-1 text-xs text-foreground-400">
                <i className="ri-thumb-up-line"></i>
                <span>{comment.likes.toLocaleString()}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}